import { tns } from 'tiny-slider/src/tiny-slider';

class BannerPostsSlider {
	constructor(el, prevButton, nextButton, nav) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;
		this.nav = nav;

		const bannerPostsSlider = tns({
			container: this.el,
            responsive: {
				641: {
					items: 1
				},
				1024: {
					items: 2
				}
			},
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			nav: true,
			navPosition: "bottom",
			navContainer: this.nav,
            gutter: 40,
		});

		return bannerPostsSlider;

	}
}

export default BannerPostsSlider;